module.exports = __webpack_public_path__ + "assets/3dc25e216ca05350cf65e23e04604900.jpg";